import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-212ab4da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-container" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "van-badge__wrapper van-icon van-icon-arrow-left van-nav-bar__arrow" }),
  /*#__PURE__*/_createElementVNode("span", { class: "return-text" }, "返回")
], -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 全部已读 ")
const _hoisted_4 = {
  class: "body-wrapper",
  ref: "listRef"
}
const _hoisted_5 = { class: "body-content" }
const _hoisted_6 = { class: "list-wrapper" }
const _hoisted_7 = { class: "list" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, " - 仅显示近100条消息 - ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_notification_item = _resolveComponent("notification-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: "消息通知",
      onClickLeft: _ctx.goBack,
      "left-arrow": ""
    }, {
      left: _withCtx(() => [
        _hoisted_2
      ]),
      right: _withCtx(() => [
        _createVNode(_component_van_button, {
          class: "filter-btn",
          size: "mini",
          onClick: _withModifiers(_ctx.readAll, ["self"])
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["onClickLeft"]),
    (!_ctx.list.length)
      ? _withDirectives((_openBlock(), _createBlock(_component_van_empty, {
          key: 0,
          description: "暂无通知"
        }, null, 512)), [
          [_vShow, !_ctx.loading]
        ])
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (noti) => {
              return (_openBlock(), _createBlock(_component_notification_item, {
                key: noti.id,
                input: noti
              }, null, 8, ["input"]))
            }), 128))
          ])
        ]),
        _hoisted_8
      ])
    ], 512), [
      [_vShow, _ctx.list.length]
    ])
  ]))
}